import type { Handler, NextFn, RequestContext } from "@ember-data/request";
import RequestManager from "@ember-data/request";
import Fetch from "@ember-data/request/fetch";
import { getOwner } from "@ember/owner";

export default class extends RequestManager {
  constructor(args?: Record<string | symbol, unknown>) {
    super(args);

    const applicationAdapter = getOwner(this)?.lookup(
      "adapter:application"
    ) as { headers: HeadersInit };

    const WiseHandler: Handler = {
      request<T>(context: RequestContext, next: NextFn<T>) {
        const headers = new Headers(applicationAdapter.headers);
        headers.append("Content-Type", "application/json");

        return next(Object.assign({}, context.request, { headers }));
      }
    };

    // @ts-expect-error RequestManager.prototype.use is not typed
    this.use([WiseHandler, Fetch]);
  }
}
